import React from 'react';
import { useTranslation } from 'react-i18next';

import FullscreenMessageWrapper from 'components/FullscreenMessageWrapper/FullscreenMessageWrapper';

const PublicUnauthorized = () => {
  const { t } = useTranslation();

  return (
    <FullscreenMessageWrapper id="public-unauthorized">
      <h2 className="heading-lg">{t('General.Unauthorized')}</h2>
      <p className="body-sm">{t('General.UnauthorizedDescription')}</p>
    </FullscreenMessageWrapper>
  );
};

export default PublicUnauthorized;
